export const loginUrl = 'https://partner-keemart.mykeeta.com';
export const signupUrl = 'https://partner-keemart.mykeeta.com/signup.html?locale=en';
